import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import twinFetchPost from '../../../../../../../utils/globals/data'
import { changeErrorMessage } from '../../../../../../../utils/reducers/reduxDispatch'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { ModalOpenedSetTy } from '../../../../../../../baseComponents/Modal/types'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'

interface ModalDeleteVariantProps extends ModalEditComponentProps { }

const ModalDeleteVariant: React.FC<ModalDeleteVariantProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleSubmit } = useModalDeleteVariantLogic({ setOpened, onSubmit })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={() => handleSubmit(allRowData || {})} translations={{
            title: t('sureDeleteVariant', '¿Seguro quieres eliminar esta variante?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

interface ModalDeleteVariantLogicProps {
    setOpened: ModalOpenedSetTy
    onSubmit: OnSubmit
}

const useModalDeleteVariantLogic = ({ setOpened, onSubmit }: ModalDeleteVariantLogicProps) => {
    const { t } = useTwinTranslation()

    const variantGroupError = t('cannotDeleteVariantGroup', 'No se puede eliminar el grupo de variante. La variante tiene valores establecidos.')

    const handleSubmit = useCallback(async (vals: TwinDictionary) => {
        const response = await twinFetchPost('/api/app/product/productVariant/deleteVariantGroup', vals)
        if (response.status === 200) {
            onSubmit?.(response, vals || {})
            setOpened(null)
        } else {
            const responseJSON = await response.json()
            if (responseJSON.errors[0].msg === 'Cannot delete variant group') {
                changeErrorMessage(variantGroupError)
            }
        }
    }, [variantGroupError, setOpened, onSubmit])
    
    return { handleSubmit }
}


export default ModalDeleteVariant